import { useParams } from 'react-router';
import { type LocalMakeWithPermissionsSpecsFragment } from '../../../api/fragments/LocalMakeWithPermissionsSpecs';
import { useGetVehicleQuery } from '../../../api/queries/getVehicle';
import LoadingElement from '../../../components/LoadingElement';
import NotFoundResult from '../../../components/results/NotFoundResult';
import MakeDetailsInnerPage from './MakeDetailsInnerPage';

const MakeDetailsPage = () => {
    const { makeId } = useParams<{ makeId: string }>();
    const { data, loading } = useGetVehicleQuery({
        fetchPolicy: 'network-only',
        variables: { id: makeId },
    });
    const make = data?.vehicle as LocalMakeWithPermissionsSpecsFragment;

    if (!make && loading) {
        return <LoadingElement />;
    }

    if (!make) {
        return <NotFoundResult />;
    }

    return <MakeDetailsInnerPage make={make} />;
};

export default MakeDetailsPage;
